import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { NotificationClient } from './notification-client.js';
import { NotificationSocketContext } from './notification-socket-context.js';
export const NotificationSocketProvider = ({ children, token, notificationsUrl, }) => {
    const socketRef = useRef(null);
    if (!socketRef.current) {
        socketRef.current = new NotificationClient(notificationsUrl);
    }
    useEffect(() => {
        if (!socketRef.current) {
            return;
        }
        if (token) {
            socketRef.current.connect();
            socketRef.current.authenticate(token);
            return;
        }
        socketRef.current.disconnect();
    }, [token]);
    useEffect(() => {
        return () => {
            socketRef.current?.disconnect();
        };
    }, []);
    return (_jsx(NotificationSocketContext.Provider, { value: socketRef.current, children: children }));
};
//# sourceMappingURL=notification-socket-provider.js.map